const limitString = (character: string, limit: number) => {
  if (character.length <= limit) {
    return character
  }
  return character.slice(0, limit) + '...'
}

export default limitString
